// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import {SecureRoute} from '@okta/okta-react';
import {CustomerRoutes} from '../literals/customer-routes';

const AddCustomer = React.lazy(() => import('../views/add-customer/add-customer'));
const CustomerProfilePage = React.lazy(() => import('../views/customer-profile/customer-profile-page'));
const CustomerSearch = React.lazy(() => import('../views/customer-search/customer-search'));
const EditCustomer = React.lazy(() => import('../views/edit-customer/edit-customer'));
const AddNewBusinessContact = React.lazy(() => import('../views/add-new-business-contact/add-new-business-contact'));
const SelectBusinessContact = React.lazy(() => import('../views/select-business-contact/select-business-contact'));
const CustomerDataShare = React.lazy(() => import('../views/customer-data-share/data-share'));
const CrossReferences = React.lazy(() => import('../views/customer-profile/customer-tile/cross-references/cross-references'));
const LogHistory = React.lazy(() => import('../views/customer-profile/customer-tile/log-history/log-history'));
const MaintainContacts = React.lazy(() => import('../views/customer-profile/customer-tile/maintain-contacts/maintain-contacts'));
const AddJDFCustomer = React.lazy(() => import('../views/add-jdf-customer/add-jdf-customer'));
const CheckHealth = React.lazy(() => import('../views/health/check-health'));
const EditJDFCustomer = React.lazy(() => import('../views/edit-jdf-customer/edit-jdf-customer'));

const crossReferences = (
    <SecureRoute
        component={CrossReferences}
        exact={true}
        path={CustomerRoutes.CROSS_REFERENCE_DETAILS}
    />
);

const dbsDataShareRoute = (
    <SecureRoute
        component={CustomerDataShare}
        exact={true}
        path={CustomerRoutes.DBS_DATA_SHARE}
    />
);

const customerProfileRoute = (
    <SecureRoute
        component={CustomerProfilePage}
        exact={true}
        path={CustomerRoutes.CUSTOMER_PROFILE}
    />
);

const editCustomerProfileRoute = (
    <SecureRoute
        component={EditCustomer}
        exact={true}
        path={CustomerRoutes.EDIT_CUSTOMER}
    />
);

const addBusinessContactRoute = (
    <SecureRoute
        component={AddNewBusinessContact}
        exact={true}
        path={CustomerRoutes.ADD_BUSINESS_CONTACT}
    />
);

const selectBusinessContactRoute = (
    <SecureRoute
        component={SelectBusinessContact}
        exact={true}
        path={CustomerRoutes.SELECT_BUSINESS_CONTACT}
    />
);

const customerSearchRoute = (
    <SecureRoute
        component={CustomerSearch}
        exact={true}
        path={CustomerRoutes.CUSTOMER_SEARCH}
    />
);

const addCustomerRoute = (
    <SecureRoute
        component={AddCustomer}
        exact={true}
        path={CustomerRoutes.ADD_CUSTOMER}
    />
);

const logHistoryRoute = (
    <SecureRoute
        component={LogHistory}
        exact={true}
        path={CustomerRoutes.LOG_HISTORY}
    />
);

const maintainContactsRoute = (
    <SecureRoute
        component={MaintainContacts}
        exact={true}
        path={CustomerRoutes.MAINTAIN_CONTACTS}
    />
);

const addJDFCustomerRoute = (
    <SecureRoute
        component={AddJDFCustomer}
        exact={true}
        path={CustomerRoutes.ADD_JDF_CUSTOMER}
    />
);

const editJDFCustomerRoute = (
    <SecureRoute
        component={EditJDFCustomer}
        exact={true}
        path={CustomerRoutes.EDIT_JDF_CUSTOMER}
    />
);
const checkHealthRoute = (
    <SecureRoute
        component={CheckHealth}
        exact={true}
        path={CustomerRoutes.CHECK_HEALTH}
    />
);

const requiresAddEditRoutes = (businessActivities) => businessActivities.canAddEdit ? {
    addBusinessContactRoute,
    addCustomerRoute,
    editCustomerProfileRoute,
    dbsDataShareRoute,
    crossReferences,
    logHistoryRoute,
    maintainContactsRoute,
    addJDFCustomerRoute,
    editJDFCustomerRoute
} : {};

export const getRouteMaps = (businessActivities, restrictAccess) => {
    if (restrictAccess) {
        return {};
    }

    return {
        ...requiresAddEditRoutes(businessActivities),
        customerProfileRoute,
        customerSearchRoute,
        selectBusinessContactRoute,
        checkHealthRoute
    };
};
